/**
 * @function validatePhone
 * @description phone number is a string formatted as '(123) 456-7890' or '1234567890' regex will validate for 10 digits only
 * @param {string} [phone='']
 * @returns boolean
 */

export function validatePhone(phone = '') {
  if (typeof phone === 'number') {
    return String(phone).match(/\d/g).length === 10;
  }
  const condition = /^(\D*\d){10}\D*$/;
  return condition.test(phone);
}

/**
 * @function formatPhoneNumber
 * @description formats phone number as "(123) 456-7890", first validating then stripping out all non-digits and reformating
 * @param {string} [phone='']
 * @returns string
 */
export function formatPhoneNumber(phone = '') {
  if (validatePhone(String(phone))) {
    phone = String(phone).trim().replace(/[\D]/g, '');
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  return phone;
}
